import React from "react";
import VendorUnansweredQuestions from "./VendorUnansweredQuestions";

const UnansweredQuestionsPage = () => {
  return (
    <VendorUnansweredQuestions />
  );
};

export default UnansweredQuestionsPage;